import { useState } from 'react';

export default (apiFunc) => {
  const [data, setData] = useState<any>(null);
  const [error, setError] = useState<any>(null);
  const [responseCode, setResponseCode] = useState(null);
  const [loading, setLoading] = useState<boolean>(false);

  const request = async (...args) => {
    setLoading(true);
    try {
      const response = await apiFunc(...args);

      setResponseCode(response?.status);
      setData(response.data);
      setError(null);
    } catch (err: any) {
      setResponseCode(err?.status);
      setData(null);
      setError(err.data);
    } finally {
      setLoading(false);
    }
  };

  return {
    data,
    error,
    loading,
    responseCode,
    request,
  };
};
